import { TOAST_AUTO_CLOSE_TIME } from '@shared/constants';

export const TOAST_OPTIONS = {
  autoClose: TOAST_AUTO_CLOSE_TIME,
  position: 'bottom-right',
};

export const getGraphQLErrorMessage = (err) =>
  err?.graphQLErrors?.[0]?.message ||
  err?.networkError?.result?.errors?.[0]?.message ||
  err?.networkError?.result?.message;

export const toToastMessage = (err, fallback) =>
  String(getGraphQLErrorMessage(err) || err?.message || fallback)
    .replace(/\s*\n\s*/g, '; ')
    .slice(0, 600);
